import { Building2, TrendingUp, Activity, ArrowUp, ArrowDown, BarChart2, Zap, AlertTriangle } from "lucide-react";

const MACRO_ICON_MAP = {
  "federal reserve": <Building2 size={18} strokeWidth={2} color="#e8c875"/>,
  "inflation":       <TrendingUp size={18} strokeWidth={2} color="#FF9500"/>,
  "economic growth": <Activity size={18} strokeWidth={2} color="#00C805"/>,
  "employment":      <Activity size={18} strokeWidth={2} color="#60A5FA"/>,
  "interest rates":  <ArrowUp size={18} strokeWidth={2} color="#FF6B35"/>,
  "earnings":        <BarChart2 size={18} strokeWidth={2} color="#e8c875"/>,
  "energy":          <Zap size={18} strokeWidth={2} color="#ffe87a"/>,
  "trade":           <ArrowDown size={18} strokeWidth={2} color="#FF3B30"/>,
  "geopolitical":    <AlertTriangle size={18} strokeWidth={2} color="#FF3B30"/>,
};

export default function MacroIcon({ theme }) {
  const key = (theme||"").toLowerCase();
  for (const [k,v] of Object.entries(MACRO_ICON_MAP)) {
    if (key.includes(k)) return v;
  }
  return <BarChart2 size={18} strokeWidth={2} color="#e8c875"/>;
}
